import { getRoute } from "@utils/route";

export const CORPORATE_INSURANCE_PAGE_URL = '/corporate-insurance';

export const routeCorporateInsurancePage = () => getRoute(CORPORATE_INSURANCE_PAGE_URL);
